import { WhispersBalanceProps } from './types';
import { StyledWhispersBalance } from './style';
import { formattingNumber } from 'utils';

export const WhispersBalance: React.FC<WhispersBalanceProps> = ({
  balance,
  balanceQuantityFormat,
}) => {
  return (
    <StyledWhispersBalance>
      {balance.image && (
        <img className="balanceImg" alt="balance" src={balance.image} />
      )}
      {balance.amount && (
        <span>
          {balanceQuantityFormat
            ? formattingNumber(
                balance.amount,
                balanceQuantityFormat,
                false,
                100,
              )
            : balance.amount}
        </span>
      )}
    </StyledWhispersBalance>
  );
};
